export const dropOffPathClicked = (startingFlow, target) => ({
  type: `User drops off from ${startingFlow} to ${target}`,
});

export const userViewsCrunchingNumbersPage = () => ({
  type: 'User views Crunching Numbers page',
});

export const onboardingInitiated = (flowType = 'Onboarding') => ({
  type: `Multistep ${flowType} Initiated`,
  data: {
    version: '3.0',
  },
});

export const getCustomerEmail = (position, customer) => {
  if (position !== 0) {
    return {
      email: customer?.email,
    };
  }
};

export const onboardingSubmitted = (
  position,
  question,
  customer,
  response,
  flowType = 'Onboarding',
) => ({
  type: `${flowType} Response Submitted`,
  data: {
    position,
    question,
    customer_info: getCustomerEmail(position, customer),
    response,
  },
});

export const onboardingBackButtonClicked = (
  start_position,
  flowType = 'Onboarding',
) => ({
  type: `${flowType} Back Button Clicked`,
  data: {
    start_position,
  },
});

export const onboardingBackArrowClicked = (page, customer) => ({
  type: 'User Leaves Step',
  data: {
    page,
    email: customer?.email,
  },
});

export const userViewsOnboardingInterstitial = previous_question => ({
  type: '[Onboarding] User views interstitial',
  data: {
    previous_question,
  },
});

export const userContinuesFromInterstitial = previous_question => ({
  type: '[Onboarding] User continues from interstitial',
  data: {
    previous_question,
  },
});

export const userViewsOnboardingIntro = () => ({
  type: 'User views Onboarding Intro',
  data: {},
});

export const userContinuesFromIntro = () => ({
  type: 'User continues from Intro',
  data: {},
});

export const onboardingBreedPageViewed = (flowType, customer) => ({
  type: '[Onboarding] User views Breed page',
  data: {
    flowType,
    email: customer?.email,
    userId: customer?.id,
  },
});

export const onboardingBreedSelected = breeds => ({
  type: '[Onboarding] Breed Selected',
  data: {
    breeds,
  },
});

export const onboardingBreedPageContinued = (breeds, flowType) => ({
  type: '[Onboarding] Breed Page Continued',
  data: {
    breeds,
    flowType,
  },
});

export const onboardingBreedPageSkipped = (
  breeds,
  preSkipBreeds = [],
  flowType,
) => ({
  type: '[Onboarding] Breed Page Skipped',
  data: {
    breeds,
    preSkipBreed: preSkipBreeds.join(', '),
    flowType,
  },
});

export const onboardingSessionStarted = ({
  isReturning,
  furthestStep,
  audienceGroup,
  inQuizAbandonerTest,
}) => ({
  type: '[Onboarding] Session Started',
  data: {
    is_returning: Boolean(isReturning),
    furthest_step: furthestStep ?? null,
    audience_group: audienceGroup ?? null,
    in_quiz_abandoner_test: Boolean(inQuizAbandonerTest),
  },
});
